const initialState = {
  alphabets: {},
  language: "",
  constants: {},
  settings: { soundLoud: 1.0 },
  game: { status: "" },
};

export default initialState;
